import React, { memo, useState, useCallback } from "react";
import { useTranslate } from "helpers";
import { MerSettingsCardProps } from "./types";
import { MerSettings } from "../../../../types";
import { TextField } from "ui/components/TextField/TextField";
import { Button } from "ui/components/Button/Button";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import MerEditCard from "./components/MerEditCard/MerEditCard";

const MerSettingsCard: React.FC<MerSettingsCardProps> = ({
  settings,
  onSave,
  isLoading = false,
}) => {
  const { t } = useTranslate();
  const [formValues, setFormValues] = useState<MerSettings>(settings);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleEditSuccess = useCallback(() => {
    onSave(formValues);
    setShowEditModal(false);
  }, [formValues, onSave]);

  return (
    <>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              {t("admin.integration.mer.settings.title")}
            </p>
            <p className="text-sm">
              {t("admin.integration.mer.settings.description")}
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1  px-3 my-3">
          <div className="flex flex-col">
            <div className="mb-3">
              <TextField
                type="text"
                name="username"
                label="Korisničko ime"
                value={formValues.username}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div className="mb-3">
              <TextField
                type="password"
                name="password"
                label="Lozinka"
                value={formValues.password}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div className="mb-3">
              <TextField
                type="text"
                name="companyId"
                label="OIB tvrtke"
                value={formValues.companyId}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div className="mb-3">
              <TextField
                type="text"
                name="companyBu"
                label="Poslovni prostor"
                value={formValues.companyBu}
                disabled
                cssClassName="bg-white"
              />
            </div>
            <div>
              <TextField
                type="text"
                name="softwareId"
                label="Software ID"
                value={formValues.softwareId}
                disabled
                cssClassName="bg-white"
              />
            </div>
          </div>
          <div>
            <Button
              variant="outlined"
              children={t("admin.edit")}
              onClick={handleEditClick}
              startIcon="/media/icons/plus.svg"
            />
          </div>
        </div>
      </div>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <ModalHeader
          title={t("admin.integration.mer.edit.title")}
          icon="/media/images/add-icon.svg"
          onHide={() => setShowEditModal(false)}
        />
        <ModalBody>
          {showEditModal && (
            <MerEditCard
              settings={formValues}
              setSettings={setFormValues}
              onSuccess={handleEditSuccess}
              onClose={() => setShowEditModal(false)}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default memo(MerSettingsCard);
